import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

function DashboardIcon(props) {
  return (
    <SvgIcon viewBox="0 0 16 13" fill="none" {...props}>
      <path
        d="M2.72258 0.756348C1.61228 0.756348 0.712227 1.65642 0.712227 2.76671V10.4426C0.712227 11.5529 1.61228 12.453 2.72258 12.453H13.3227C14.4329 12.453 15.333 11.5529 15.333 10.4426V2.76671C15.333 1.65642 14.4329 0.756348 13.3227 0.756348H2.72258ZM10.9437 1.85291H13.3227C13.8273 1.85291 14.2364 2.26202 14.2364 2.76671V10.4426C14.2364 10.9473 13.8273 11.3564 13.3227 11.3564H10.9437V1.85291ZM2.72258 1.85291H9.84709V11.3564H2.72258C2.21787 11.3564 1.80879 10.9473 1.80879 10.4426V2.76671C1.80879 2.26202 2.21787 1.85291 2.72258 1.85291Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export default DashboardIcon;
